import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Container, Typography } from '@mui/material';
import Blog from '../Blog/Blog';
import Navigation from '../../Shared/Navigation/Navigation';
import Footer from '../../Shared/Footer/Footer';
import './Blogs.css';






const Blogs = () => {
    // useState for products 
    const [blogs, setBlogs] = useState([]);
    const spinnerStyle = {
        width: "3rem",
        height: "3rem",
    };
    // useEffect for products 
    useEffect(() => {
        fetch('https://warm-oasis-84574.herokuapp.com/blogs')
            .then(res => res.json())
            .then(data => setBlogs(data));
    }, [])

    return (
        <>
            <Navigation></Navigation>
            <div>
                {/* Heading  */}
                <h1 className="heading">
                    <span>L</span>
                    <span>A</span>
                    <span>T</span>
                    <span>E</span>
                    <span>S</span>
                    <span>T</span>
                    <span className="space">{""}</span>
                    <span>B</span>
                    <span>L</span>
                    <span>O</span>
                    <span>G </span>
                    <span>S </span>
                </h1>

                {/* Spinner and Photos  */}
                {!blogs.length ? (
                    <div className="text-center my-5 py-5">
                        <div
                            className="spinner-grow color-1 mt-5"
                            style={spinnerStyle}
                            role="status"
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="photos">
                        {blogs.map((blog) => (
                            <Blog key={blog._id} blog={blog}></Blog>
                        ))}
                    </div>

                )}
            </div>
            <Footer></Footer>

        </>

        // <Box sx={{ flexGrow: 1, my: 5 }}>
        //     <Container >
        //         <Typography variant="h4" component="div" sx={{ fontWeight: 500, my: 3, color: "secondary.main" }}>
        //             Latest Blogs
        //         </Typography>

        //         <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        //             {
        //                 blogs.map(blog => <Blog key={blog._id} blog={blog} />)

        //             }

        //         </Grid>
        //     </Container >
        // </Box>

    );

};
export default Blogs;